//@author:Himanshu Barmola



// Customizating the PasswordInput field for Redux-Form

import React, { useState } from "react"
import { Input, InputGroup } from "rsuite"
import { RiEye2Line, RiEyeCloseLine } from "react-icons/all"

export const PasswordInput = (props) => {
    const [eye, setEye] = useState(false)
    const {icon:Icon}=props
    return (
        <div className="input-field">
            <InputGroup inside
            >
                  <InputGroup.Addon onClick={() => setEye(!eye)} >
                    {eye ? <RiEye2Line size={22} /> : <RiEyeCloseLine size={22} />}
                </InputGroup.Addon>
                <Input
                    {...props.input}
                    placeholder={props.placeholder}
                    value={props.input.value}
                    name={props.input.name}
                    type={eye ? "text" : "password"}
                    block="true"
                    size="lg"
                 className={props.meta.touched && props.meta.error != undefined ? "error-field" : undefined}
                />               
            </InputGroup>
            <p className="error-msg">{props.meta.touched ? props.meta.error : ""}</p>
        </div>
    )
}



export default PasswordInput